import {
  ERROR_EVENT,
  ANNOTATABLE_SELECTION_EVENT,
  ANNOTATABLE_SELECTION_CLEAR_EVENT,
  READ_ONLY_EVENT,
  SET_STATE_FROM_VERSION_EVENT,
  DIFF_MODE_EVENT,
  HISTORY_MODE_EVENT,
  CREATE_TMP_ANNOTATION_EVENT,
  CREATE_ANNOTATION_EVENT,
  ACTIVATE_ANNOTATION_EVENT,
  CANCEL_CREATE_ANNOTATION_EVENT,
  REMOVE_ANNOTATION_EVENT
} from './api';

function throwInvalidEventWarning(type, events) {
  console.error(
    `${type} is not a defined event type. Valid event types are: ${events.map(
      eventType => eventType
    )}`
  );
}

export default class ConsumerApi {
  all;
  editorReady;
  events;
  readyEventsQueue;
  constructor() {
    this.events = [
      ERROR_EVENT,
      READ_ONLY_EVENT,
      SET_STATE_FROM_VERSION_EVENT,
      DIFF_MODE_EVENT,
      HISTORY_MODE_EVENT,
      ANNOTATABLE_SELECTION_EVENT,
      ANNOTATABLE_SELECTION_CLEAR_EVENT,
      CREATE_TMP_ANNOTATION_EVENT,
      CREATE_ANNOTATION_EVENT,
      ACTIVATE_ANNOTATION_EVENT,
      CANCEL_CREATE_ANNOTATION_EVENT,
      REMOVE_ANNOTATION_EVENT
    ];
    this.all = this.events.reduce((map, eventType) => {
      map[eventType] = [];
      return map;
    }, {});
    this.readyEventsQueue = [];
    this.editorReady = false;
  }

  on(type, handler) {
    if (this.all[type]) {
      this.all[type].push(handler);
    } else {
      throwInvalidEventWarning(type, this.events);
    }
  }

  off(type, handler) {
    if (this.all[type]) {
      this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
    } else {
      throwInvalidEventWarning(type, this.events);
    }
  }

  emit(type, payload) {
    if (this.all[type]) {
      if (!this.editorReady) {
        this.readyEventsQueue.push([type, payload]);
      } else {
        this.all[type].map((handler) => {
          handler(payload);
        });
      }
    } else {
      throwInvalidEventWarning(type, this.events);
    }
  }

  ready() {
    while (this.readyEventsQueue.length > 0) {
      const [type, payload] = this.readyEventsQueue.shift();
      this.all[type].map((handler) => {
        handler(payload);
      });
    }
    this.editorReady = true;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/ConsumerApi.js